export default {
  popularSearches: {
    id: 'searchbar_popular_searches_title',
    defaultMessage: 'Popular searches',
  },
  suggestedSearches: {
    id: 'searchbar_suggested_searches_title',
    defaultMessage: 'Suggested searches',
  },
  suggested: {
    id: 'searchbar_suggested_title',
    defaultMessage: 'Suggested',
  },
  searchFor: {
    id: 'searchbar_search_for',
    defaultMessage: 'Search for "{searchQuery}"',
  },
  recentlyViewed: {
    id: 'searchbar_recently_viewed_title',
    defaultMessage: 'Recent',
  },
  cancelLabel: {
    id: 'searchbar_cancel_label',
    defaultMessage: 'Cancel',
  },
  resultsListing: {
    id: 'searchbar_results_listing_count',
    defaultMessage: '{resultsCount} results for "{searchQuery}"',
  },
  textboxPlaceholder: {
    id: 'searchbar_placeholder',
    defaultMessage: 'Looking for something (refurbished) in particular?',
  },
  searchWithAi: {
    id: 'searchbar_search_with_ai',
    defaultMessage: 'Ask me…',
  },
  newConversationDialogTitle: {
    id: 'shopping_assistant_new_conversation_dialog_title',
    defaultMessage: 'Are you sure?',
  },
  newConversationDialogDescription: {
    id: 'shopping_assistant_new_conversation_dialog_description',
    defaultMessage:
      'Doing this will start a new conversation and your current conversation will be lost.',
  },
  newConversationDialogPositiveButton: {
    id: 'shopping_assistant_new_conversation_dialog_positive_button',
    defaultMessage: 'Start new conversation',
  },
  newConversationDialogNegativeButton: {
    id: 'shopping_assistant_new_conversation_dialog_negative_button',
    defaultMessage: 'Cancel',
  },
}
